import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth-store'
import { AuthProvider } from '@/providers/auth-provider'
import { ThemeProvider } from '@/providers/theme-provider'
import { Shell } from '@/components/layout/shell'
import { ErrorBoundary } from '@/components/ui/error-boundary'
import LoginPage from '@/pages/login'
import DashboardPage from '@/pages/dashboard'
import ProfilePage from '@/pages/profile'
import HomePage from '@/pages/home'
import HomepageSettingsPage from '@/pages/homepage-settings'
import AboutSettingsPage from '@/pages/about-settings'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user)
  const initialized = useAuthStore((s) => s.initialized)

  if (!initialized) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <p className="text-sm text-muted-foreground">Memuat...</p>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function wrap(element: React.ReactNode) {
  return <ErrorBoundary>{element}</ErrorBoundary>
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <Shell />
                </RequireAuth>
              }
            >
              <Route index element={wrap(<DashboardPage />)} />
              <Route path="homepage" element={wrap(<HomepageSettingsPage />)} />
              <Route path="about" element={wrap(<AboutSettingsPage />)} />
              <Route path="profile" element={wrap(<ProfilePage />)} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}
